import { useState } from "react";
import { Icon } from "./icon/Icon";

type Option = {
  label: string;
  value: string;
};

type SelectProps = {
  value: string;
  onChange: (value: string) => void;
  options: Option[];
};

const Select: React.FC<SelectProps> = ({ value, onChange, options }) => {
  const [showOptions, setShowOptions] = useState(false);
  const selected = options.find((option) => option.value === value);

  const toggleShowOptions = () => {
    setShowOptions(!showOptions);
  };

  return (
    <div className="w-full relative">
      <button
        onClick={toggleShowOptions}
        className="w-full flex items-center justify-between bg-bg rounded-[0.75rem] px-4 py-[0.9375rem]"
      >
        <p className="text-[1.0625rem] leading-[1.375rem]">{selected?.label}</p>

        <Icon
          type="chevron-vertical"
          className={`fill-secondary-hint ${
            showOptions && "opacity-35"
          } w-5 h-5`}
        />
      </button>

      {showOptions && (
        <>
          <button
            onClick={toggleShowOptions}
            className="fixed left-0 top-0 w-full h-full z-10"
          ></button>

          <div className="absolute right-0 top-[calc(100%+0.5rem)] bg-bg rounded-[0.75rem] z-20 flex flex-col shadow-context-menu">
            {options.map(({ label, value }, index) => (
              <div key={index}>
                <button
                  onClick={() => {
                    onChange(value);
                    toggleShowOptions();
                  }}
                  className="px-4 py-3 text-[1.0625rem] leading-[1.375rem]"
                >
                  {label}
                </button>
                {index < options.length - 1 && (
                  <div className="w-full pl-4">
                    <div className="w-full h-px bg-divider"></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Select;
